<template>
  <div class="reports-completed-view">
    <table-component
      v-if="upcomingReports && upcomingReports.length"
      :content="upcomingReports"
      :headings="report_headings"
      :item_keys="report_keys"
      :display_spec="certificateReportSpecs"
      class="reports-table">
    </table-component>
    <message-component v-if="!upcomingReports || !upcomingReports.length" :level="'info'">
      <translate>There are no upcoming reports.</translate>
    </message-component>
  </div>
</template>
<script>
  import { mapState, mapGetters } from 'vuex'
  import { certificateReportSpecs, certificateSpecs } from '@/display_context/display_context'
  import TableComponent from '@/components/layout/table/TableComponent'
  import { sortPeriodDates } from '@/utility/utility_functions'
  import MessageComponent from '@/components/layout/utility/MessageComponent'

  export default {
    name: 'reports-completed-view',
    components: {
      TableComponent,
      MessageComponent
    },
    data () {
      return {
        report_headings: ['Period'],
        report_keys: ['periodDate'],
        certificateSpecs: certificateSpecs,
        certificateReportSpecs: certificateReportSpecs
      }
    },
    props: {
      certificateId: {
        required: true
      }
    },
    computed: {
      ...mapState({
        certificates: state => state.certificateModule.certificates
      }),
      ...mapGetters([
        'getCertificateForId'
      ]),
      upcomingReports () {
        return this.certificate.reports && this.certificate.reports.filter(report => {
          return !report.isReported
        }).sort(sortPeriodDates).map(report => {
          report.isHidden = true
          return report
        })
      },
      certificate () {
        return this.getCertificateForId(this.certificateId) || {}
      }
    }
  }
</script>
<style lang="sass" scoped>
  .reports-completed-view
    overflow: hidden
</style>
